import { useRef, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UserContext from '../context/UserContext';
import axios from 'axios';

const SignIn = () => {
  const navigate = useNavigate();
  const form = useRef(null);
  const { user, setUser } = useContext(UserContext);
  const [enterdPhoneNumber, setEnterdPhoneNumber] = useState('');

  const onLogin = (e) => {
    e.preventDefault();
    const phoneNumber = user?.phoneNumber || enterdPhoneNumber;
    const code = form.current.code.value;

    const formData = new FormData();
    formData.append('phone', phoneNumber);
    formData.append('code', code);

    const login = async () => {
      const res = await axios({
        method: 'post',
        url: '/signin',
        data: formData,
      });

      const data = await res.data;

      setUser({ phoneNumber, data });

      localStorage.setItem('user', JSON.stringify(data));

      navigate('/');
    };

    login();
  };

  const setValue = (e) => {
    setEnterdPhoneNumber(e.target.value);
  };

  return (
    <div className="w-full h-full my-auto flex justify-center items-center">
      <form
        ref={form}
        className="w-96 h-full flex flex-col justify-between items-center p-5 rounded-lg bg-white"
        style={{ direction: 'rtl' }}
        onSubmit={onLogin}
      >
        <h2 className="w-full font-bold text-center text-xl">
          لطفا کد ارسال شده را وارد کنید
        </h2>

        <div className="w-full flex flex-col justify-between items-start font-semibold my-5">
          <label htmlFor="phoneNumber" className="mb-3 text-lg">
            شماره تماس:
          </label>
          {user?.phoneNumber ? (
            <input
              className="w-full border-gray-400 border rounded-lg p-1 appearance-none"
              type="number"
              id="phoneNumber"
              value={user?.phoneNumber}
              disabled
            />
          ) : (
            <input
              className="w-full border-gray-400 border rounded-lg p-1 px-2 appearance-none"
              type="number"
              id="phoneNumber"
              onChange={setValue}
              value={enterdPhoneNumber}
            />
          )}
        </div>

        <div className="w-full flex flex-col justify-between items-start font-semibold my-5 mt-0">
          <label htmlFor="code" className="mb-3 text-lg">
            کد:
          </label>
          <input
            className="w-full border-gray-400 border rounded-lg p-1 px-2 appearance-none"
            type="number"
            id="code"
          />
        </div>

        <div className='w-full flex justify-start items-center gap-2 mb-4'>
          <input type="checkbox" name="remember" id="remember" /> 
          <span>مرا به خاطر بسپار</span>
        </div>

        <button
          type="submit"
          className="bg-green-500 w-full p-1 rounded-md font-bold"
        >
          ورود
        </button>
      </form>
    </div>
  );
};

export default SignIn;
